module.exports = __webpack_public_path__ + "static/media/0_2018_09_24.775e6d7f.jpg";